import { render, staticRenderFns } from "./pubFooter.vue?vue&type=template&id=24812b7c&scoped=true&"
import script from "./pubFooter.vue?vue&type=script&lang=js&"
export * from "./pubFooter.vue?vue&type=script&lang=js&"
import style0 from "./pubFooter.vue?vue&type=style&index=0&id=24812b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24812b7c",
  null
  
)

export default component.exports